// Tyler.API.MetaData.SelectionMode
export enum SelectionMode {
    None = 0,
    Single = 1,
    Multiple = 2
}
